import React from 'react';
import PropTypes from 'prop-types';
import * as Classes from './TableTitle.module.scss';
import { testAttributes } from '../Constants';

export default function TableTitle({ label = 'In This Article' }) 
{
    return (
        <p
            className={Classes.tableTitle}
            data-testid={testAttributes.TABLE_OF_CONTENT_TITLE}
        >
            {label}
            <meta content={label} itemProp="name" />
        </p>
    );
}

TableTitle.propTypes = {
    /** Table of content title */
    label: PropTypes.string,
};
